<template>
<div class="vld-parent">
    <loading v-model="isLoading"
                 :active="isLoading"
                 :can-cancel="false"
                 :on-cancel="onCancel"
                 :is-full-page="true"/>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Add Account</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>XLXS File</label>
                        <input type="file" ref="fileInput" 
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        class="form-control mb-4" @change="onFilePicked" style="height: 45px"/>
                    </div>
                </div>
                <!-- Sign in button -->
                <button class="btn btn-info btn-block my-4" @click.prevent="addStudents()">Add Students</button>
                <!--  <button class="btn btn-danger btn-block my-4" @click.prevent="deleteAllStudents()">Delete Students</button> -->

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<script>
// import axios from "axios"
import * as XLSX from 'xlsx';
import axios from "axios"
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'AddStudents',
    components: {
        Loading
    },
    data() {
        return {
            fastAdminToken : localStorage.getItem("fastAdminToken"),
            file: null,
            data: null,
            isLoading: false,
        }
    },
    methods: {
        onCancel() {
            console.log('User cancelled the loader.')
        },
        addStudents() {
            if (this.file == null) {
                this.$toast.open({
                    message: "ERROR : File is required",
                    type: 'error'
                })
            } else {
                var reuqest_data = [];

                for(var i=1; i < this.data.length; i++) {
                    var item_data = {};
                    if(this.data[i].length) {
                        item_data['class'] = this.data[i][2];
                        item_data['name'] = this.data[i][3];
                        item_data['first_name'] = this.data[i][4];
                        item_data['last_name'] = this.data[i][5];
                        item_data['username'] = this.data[i][1];
                        item_data['gender'] = this.data[i][6];
                        item_data['level'] = this.data[i][9];
                        item_data['age_bracket'] = this.data[i][7];
                        item_data['type'] = this.data[i][10];
                        item_data['registration_date'] = this.data[i][11];
                        item_data['starting_age'] = this.data[i][12];
                        item_data['school_grade'] = this.data[i][13];
                        item_data['class_day'] = this.data[i][17];
                        item_data['class_schedule'] = this.data[i][18];
                        item_data['guardian_name'] = this.data[i][20];
                        item_data['guardian_phone'] = this.data[i][21];
                        item_data['guardian_phone_b'] = this.data[i][22];
                        item_data['guardian_email'] = this.data[i][23];
                        item_data['guardian_email_b'] = this.data[i][24];
                        item_data['teacher_email'] = this.data[i][16];
                        item_data['group'] = this.data[i][19];
                        reuqest_data.push(item_data);
                    }
                }

                this.data = null;
                this.file = null;
                this.$refs.fileInput.value = null;
                
                this.$toast.open({
                    message: "Processing : Uploading... Please Wait...",
                    type: 'info'
                })

                this.isLoading = true;

                const config = {
                    headers: {
                        Authorization: "Bearer " + this.fastAdminToken,
                        'Content-Type': 'application/json'
                    }
                }

                axios.post(this.$apiURI + "/account/massive/upload", {
                    data: reuqest_data
                }, config)
                    .then((response) => {
                        this.isLoading = false

                        if (response.data.error) {
                            this.$toast.open({
                                message: "Error : " + response.data.message,
                                type: 'error'
                            });
                        } else {
                            this.$toast.open({
                                message: "Uploaded Successfully",
                                type: 'success'
                            })
                        }

                    }).catch((error) => {

                        this.isLoading = false

                        this.$toast.open({
                            message: "Error : " + error.response.data.message,
                            type: 'error'
                        });
                    });

            }
        },


        deleteAllStudents() {
            const config = {
                    headers: {
                        Authorization: "Bearer " + this.fastAdminToken,
                        'Content-Type': 'application/json'
                    }
                }

                axios.post(this.$apiURI + "/account/massive/delete", {
                    data: 'all'
                }, config);
        },

        onFilePicked (event) {
            this.file = event.target.files ? event.target.files[0] : null;
            if (this.file) {
                const reader = new FileReader();

                reader.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target.result;
                    const wb = XLSX.read(bstr, { type: 'binary' });
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    this.data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                }

                reader.readAsBinaryString(this.file);
            }
        }
    }
}
</script>
